import { IMediationSpaceRepository, GeoJsonValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class MediationSpaceRepository implements IMediationSpaceRepository {
  async getCentroids(): Promise<GeoJsonValueObject> {
    const response = await axiosClient.get<GeoJsonValueObject>('/mediation-spaces/centroids');
    return response.data;
  }

  async getGeometry(spaceId: string | number): Promise<GeoJsonValueObject> {
    const response = await axiosClient.get<GeoJsonValueObject>(`/mediation-spaces/${spaceId}/geometry`);
    return response.data;
  }

  async getAllWithData(): Promise<GeoJsonValueObject> {
    const response = await axiosClient.get<GeoJsonValueObject>('/mediation-spaces/all-with-data');
    return response.data;
  }
}
